<template>
  <div class="indexPage custom_style" :class="isShow ? 'fixedStyle' : ''">
    <div class="head flex-rowl">
      <i class="iconfont icon-gongnenglan-kehuguanli"></i>
      <div class="content">
        <h1>我的</h1>
        <p>业务通知管理设置</p>
      </div>
    </div>

    <!--  主要内容 start -->
    <div class="container_wrap">
      <div class="block">
        <div class="tit flex-rowl">
          <span class="mark">*</span>待审批的企业成员申请通知人
        </div>
        <div class="column flex-rowc" @click="handleShow('selectUser')">
          <i class="iconfont icon-yuangongguanli"></i>
          选择待审批的企业成员申请通知人
        </div>
        <div class="column two" v-if="formData.mobile_user">
          <div class="item flex-rowl">
            <p class="label">员工姓名：</p>
            <p>{{ selectUser.truename }}</p>
          </div>
          <div class="depart_box flex-rowl">
            <p>部门：</p>
            <div class="depart_wrap">
              <div class="depart flex-between">
                {{ selectUser.deptname }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
              <div class="depart flex-between">
                {{ selectUser.rolename }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="tit flex-rowl">
          <span class="mark">*</span>待审批的合作商家申请通知人
        </div>
        <div class="column flex-rowc" @click="handleShow('selectCmuser')">
          <i class="iconfont icon-yuangongguanli"></i>
          请选择待审批的合作商家申请通知人
        </div>
        <div class="column two" v-if="formData.mobile_cmuser">
          <div class="item flex-rowl">
            <p class="label">员工姓名：</p>
            <p>{{ selectCmuser.truename }}</p>
          </div>
          <div class="depart_box flex-rowl">
            <p>部门：</p>
            <div class="depart_wrap">
              <div class="depart flex-between">
                {{ selectCmuser.deptname }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
              <div class="depart flex-between">
                {{ selectCmuser.rolename }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="tit flex-rowl">
          <span class="mark">*</span>待发货的订单通知人
        </div>
        <div class="column flex-rowc" @click="handleShow('selectSendgoods')">
          <i class="iconfont icon-yuangongguanli"></i>
          请选择待发货的订单通知人
        </div>
        <div class="column two" v-if="formData.mobile_sendgoods">
          <div class="item flex-rowl">
            <p class="label">员工姓名：</p>
            <p>{{ selectSendgoods.truename }}</p>
          </div>
          <div class="depart_box flex-rowl">
            <p>部门：</p>
            <div class="depart_wrap">
              <div class="depart flex-between">
                {{ selectSendgoods.deptname }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
              <div class="depart flex-between">
                {{ selectSendgoods.rolename }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="tit flex-rowl">
          <span class="mark">*</span>待审核的退款申请通知人
        </div>
        <div class="column flex-rowc" @click="handleShow('selectCheckreturn')">
          <i class="iconfont icon-yuangongguanli"></i>
          请选择待审核的退款申请通知人
        </div>
        <div class="column two" v-if="formData.mobile_checkreturn">
          <div class="item flex-rowl">
            <p class="label">员工姓名：</p>
            <p>{{ selectCheckreturn.truename }}</p>
          </div>
          <div class="depart_box flex-rowl">
            <p>部门：</p>
            <div class="depart_wrap">
              <div class="depart flex-between">
                {{ selectCheckreturn.deptname }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
              <div class="depart flex-between">
                {{ selectCheckreturn.rolename }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="custom_btn" @click="query">保存</div>
    </div>
    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
    <!--  主要内容 end -->

    <!-- 弹窗 -->
    <van-overlay :show="isShow">
      <div class="popup-wrap">
        <i class="iconfont icon-jujueweituo" @click="handleCancel"></i>
        <div class="popup-main">
          <div class="search_wrap flex-between">
            <div class="search_box flex-rowl">
              <i class="iconfont icon-search"></i>
              <div class="input">
                <van-field
                  v-model="customerParams.keyword"
                  placeholder="输入员工姓名/ID/部门，查找后选择员工"
                />
              </div>
            </div>
            <div class="btn" @click="getApplyCompanyList">查找显示</div>
          </div>
          <div class="scroll_wrap">
            <template v-if="qyUserList.length > 0">
              <div
                class="list flex-rowl"
                v-for="(item, index) in qyUserList"
                :key="index"
                @click="handleRadio(item.id)"
              >
                <div class="radio" :class="{ active: selectQyId === item.id }">
                  <i class="iconfont icon-gouxuan"></i>
                </div>
                <div class="content">
                  <div class="cont_item flex-rowl">
                    <p class="label">员工姓名：</p>
                    <p>{{ item.user.truename }}</p>
                  </div>
                  <!-- <div class="cont_item flex-rowl">
                  <p class="label">账号：</p>
                  <p>{{ item.accountid }}</p>
                </div> -->
                  <div class="depart_box flex-rowl">
                    <p>部门：</p>
                    <div class="depart flex-between">
                      {{ item.deptname }}
                      <i class="iconfont icon-wenjianjia_o"></i>
                    </div>
                  </div>
                  <div class="depart_box rolename_box flex-rowl">
                    <p>角色：</p>
                    <div class="depart flex-between">
                      {{ item.rolename }}
                      <i class="iconfont icon-wenjianjia_o"></i>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <van-empty description="暂无成员" v-else />
          </div>
        </div>
        <div class="popup-bottom flex-rowc">
          <div class="custom_btn next" @click="handleQueryQy">
            确认<span><i class="iconfont icon-selected"></i></span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { encryptstringview } from "../../api/api";
import {
  editQyNotice,
  getQyNoticeDetail,
  getApplyCompanyList,
} from "../../api/company";
export default {
  name: "serviceNitoceManage",
  data() {
    return {
      loading: false,
      id: "",
      qyguid: "",
      formData: {
        mobile_user: "",
        mobile_cmuser: "",
        mobile_sendgoods: "",
        mobile_checkreturn: "",
      },

      qyid: "",

      isShow: false,
      qyUserList: [],
      selectQyId: "",
      selectQy: {}, // 选择的企业
      customerParams: {
        qyid: "",
        keyword: "",
        checkstate: 1, // 0审核中 1已通过 2拒绝加入 3已退出 4已被移出
      },
      selectUser: {}, // 待审批的企业成员申请通知人
      selectCmuser: {}, // 待审批的合作商家申请通知人
      selectSendgoods: {}, // 待发货的订单通知人
      selectCheckreturn: {}, // 待审核的退款申请通知人
      selectType: "selectUser",
    };
  },
  computed: {
    isDisabled() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.pernumCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
    isDisabled1() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.ruleCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.customerParams.qyid = USERINFO.qy.id ? USERINFO.qy.id : "";
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyguid, qyid, id } = JSON.parse(res.jsondata);
        this.qyguid = qyguid;
        this.id = id;
        this.qyid = qyid;

        this.getApplyCompanyList(false, "");
      } else {
        this.$router.back();
      }
    },

    // 关系选择员工弹窗
    handleCancel() {
      this.isShow = false;
    },

    handleShow(type) {
      this.getApplyCompanyList(true, type);
      this.selectType = type;
      this.isShow = true;
    },

    // 员工选择
    handleUser(id) {
      this.selectQyId = id;
    },
    // 员工选择
    handleRadio(id) {
      this.selectQyId = id;
    },
    // 选中员工
    handleQueryQy() {
      let { selectQyId, qyUserList, selectType } = this;
      if (selectQyId == "") {
        this.$message.warning("请选择员工");
      } else {
        qyUserList.forEach((v) => {
          if (v.id == selectQyId) {
            this[selectType].id = v.id;
            this[selectType].truename = v.user.truename;
            this[selectType].deptname = v.deptname;
            this[selectType].rolename = v.rolename;
            if (selectType == "selectUser") {
              this.formData.mobile_user = v.user.truename + " | " + v.mobile;
            }
            if (selectType == "selectCmuser") {
              this.formData.mobile_cmuser = v.user.truename + " | " + v.mobile;
            }
            if (selectType == "selectSendgoods") {
              this.formData.mobile_sendgoods =
                v.user.truename + " | " + v.mobile;
            }
            if (selectType == "selectCheckreturn") {
              this.formData.mobile_checkreturn =
                v.user.truename + " | " + v.mobile;
            }
          }
        });
        this.isShow = false;
      }
    },

    getApplyCompanyList(isClick, type) {
      getApplyCompanyList(this.customerParams).then((res) => {
        this.qyUserList = res;
        if (isClick && type != "") {
          res.forEach((v) => {
            if (v.id == this[type].id && this[type].id) {
              this.selectQy = v;
              this.selectQyId = this[type].id;
            }
          });
        } else {
          this.getQyNoticeDetail();
        }
      });
    },

    // 获取企业通知详情
    getQyNoticeDetail() {
      let { qyUserList } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getQyNoticeDetail({ id: this.id }).then((res) => {
        this.formData.mobile_user = res.mobile_user ? res.mobile_user : "";
        let mobile_user = res.mobile_user
          ? res.mobile_user.split(" | ")[1]
          : "";
        this.formData.mobile_cmuser = res.mobile_cmuser
          ? res.mobile_cmuser
          : "";
        let mobile_cmuser = res.mobile_cmuser
          ? res.mobile_cmuser.split(" | ")[1]
          : "";
        this.formData.mobile_sendgoods = res.mobile_sendgoods
          ? res.mobile_sendgoods
          : "";
        let mobile_sendgoods = res.mobile_sendgoods
          ? res.mobile_sendgoods.split(" | ")[1]
          : "";
        this.formData.mobile_checkreturn = res.mobile_checkreturn
          ? res.mobile_checkreturn
          : "";
        let mobile_checkreturn = res.mobile_checkreturn
          ? res.mobile_checkreturn.split(" | ")[1]
          : "";
        qyUserList.forEach((v) => {
          if (v.mobile == mobile_user) {
            this.selectUser.id = v.id;
            this.selectUser.truename = v.user.truename;
            this.selectUser.deptname = v.deptname;
            this.selectUser.rolename = v.rolename;
          }
          if (v.mobile == mobile_cmuser) {
            this.selectCmuser.id = v.id;
            this.selectCmuser.truename = v.user.truename;
            this.selectCmuser.deptname = v.deptname;
            this.selectCmuser.rolename = v.rolename;
          }
          if (v.mobile == mobile_sendgoods) {
            this.selectSendgoods.id = v.id;
            this.selectSendgoods.truename = v.user.truename;
            this.selectSendgoods.deptname = v.deptname;
            this.selectSendgoods.rolename = v.rolename;
          }
          if (v.mobile == mobile_checkreturn) {
            this.selectCheckreturn.id = v.id;
            this.selectCheckreturn.truename = v.user.truename;
            this.selectCheckreturn.deptname = v.deptname;
            this.selectCheckreturn.rolename = v.rolename;
          }
        });
        Toast.clear();
      });
    },

    query() {
      let { formData, id, qyguid } = this;
      if (formData.mobile_user == "") {
        this.$toast("请选择待审批的企业成员申请通知人");
        return;
      }
      if (formData.mobile_cmuser == "") {
        this.$toast("请选择待审批的合作商家申请通知人");
        return;
      }
      if (formData.mobile_sendgoods == "") {
        this.$toast("请选择待发货的订单通知人");
        return;
      }
      if (formData.mobile_checkreturn == "") {
        this.$toast("请选择待审核的退款申请通知人");
        return;
      }
      this.formData.id = id;
      this.formData.qyguid = qyguid;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editQyNotice(formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$router.back();
          }, 500);
        } else {
          Toast.clear();
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  box-sizing: border-box;
  &.fixedStyle {
    overflow: hidden;
    height: 100vh;
  }
  .head {
    .icon-gongnenglan-kehuguanli {
      font-size: 44px;
    }
  }
  /deep/ .van-cell {
    background: none;
    height: 100%;
    padding: 0;
  }
  .container_wrap {
    padding: 70px 83px;
    box-sizing: border-box;
    font-size: 22px;
    color: #3c3c3c;
    .block {
      margin-bottom: 80px;
      .item {
        margin-bottom: 18px;
        .label {
          width: 140px;
          flex-shrink: 0;
        }
      }
      .tit {
        font-size: 24px;
        color: #333333;
        margin-bottom: 20px;
        .iconfont {
          font-size: 34px;
          margin-right: 10px;
        }
      }
      .column {
        border: 1px solid #aaaaaa;
        font-size: 28px;
        color: #333333;
        margin-bottom: 39px;
        height: 110px;
        .icon-yuangongguanli {
          font-size: 44px;
          margin-right: 20px;
        }
        &.two {
          height: auto;
          margin-bottom: 0;
          padding: 44px 0 44px 30px;
          font-size: 22px;
        }
      }
      .remark {
        h1 {
          font-size: 22px;
          color: #aaaaaa;
          margin-bottom: 20px;
        }
        .textarea {
          padding: 20px;
          box-sizing: border-box;
          background: #fafafa;
          height: 300px;
          width: 100%;
        }
      }
      .input {
        border-bottom: 1px dashed #c3c3c3;
        padding: 26px 14px;
        box-sizing: border-box;
      }
    }
    .custom_btn {
      width: 280px;
      height: 50px;
      line-height: 50px;
    }
  }
  .depart_box {
    // margin-top: 20px;
    align-items: flex-start;
    .depart {
      border: 1px solid #aaaaaa;
      font-size: 18px;
      width: 190px;
      height: 40px;
      padding: 0 20px;
      box-sizing: border-box;
      margin-left: 30px;
      border-radius: 20px;
    }
    &.rolename_box {
      margin-top: 15px;
    }
  }
  .depart_wrap {
    .depart {
      margin-bottom: 10px;
    }
  }
  .popup-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    height: 75%;
    font-size: 22px;
    color: #3c3c3c;
    .icon-jujueweituo {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -90px;
      color: #fff;
      font-size: 50px;
    }
    .popup-main {
      .search_wrap {
        width: 660px;
        border-bottom: 1px solid #dddddd;
        margin: 56px auto 49px;
        padding-bottom: 29px;
        box-sizing: border-box;

        .search_box {
          color: #c8c8c8;
          flex: 1;
          .input {
            flex: 1;
            padding: 0 16px;
          }
          .iconfont {
            font-size: 36px;
            color: #565757;
          }
        }
        .btn {
          width: 130px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          background: #1e1e1e;
          font-size: 18px;
          color: #fff;
        }
      }
      .scroll_wrap {
        height: 50vh;
        overflow-y: scroll;
        .list {
          width: 600px;
          border: 1px solid #dcdcdc;
          padding: 44px 30px;
          box-sizing: border-box;
          margin: 0 auto 30px;
          .radio {
            margin-right: 28px;
            color: #dadada;
            .iconfont {
              font-size: 40px;
            }
            &.active {
              color: #333333;
            }
          }
          .cont_item {
            margin-bottom: 25px;

            .label {
              width: 140px;
            }
          }
        }
      }
    }
    .popup-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 200px;
      box-shadow: 0 -1px 8px 2px rgba(0, 0, 0, 0.05);
      .custom_btn {
        width: 500px;
        height: 60px;
        line-height: 60px;
        border-radius: 0;
        margin: 0 auto 60px;
      }
    }
  }
}
</style>